import { Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";

@Injectable({ providedIn: "root" })
export class NotificationService {
  constructor(private snackBar: MatSnackBar) {}

  public error(message: string): void {
    this.open(message, "app-snack-error");
  }

  public notify(message: string): void {
    this.open(message, "app-snack-default");
  }

  private open(message: string, panelClass: string): void {
    this.snackBar.open(message, "✕", {
      duration: 12000,
      panelClass,
      horizontalPosition: "end",
      verticalPosition: "top"
    });
  }
}
